export default __webpack_public_path__ + "static/second-image-bb0a4565967a7c092869067c2bf7a970.gif";